
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[vertical]/article/[articleslug]",
      function () {
        return require("private-next-pages/[market]/[vertical]/article/[articleslug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[vertical]/article/[articleslug]"])
      });
    }
  